import classNames from 'classnames';

import Grid from '~components/_layout/Grid/Grid';
import constants from '~globals/constants';
import { useAppSelector } from '~hooks/useRedux';

type Props = {
    heading?: string;
    description?: string;
    backgroundsurface?: SupportedBackgroundColor;
    textColor?: SupportedTextColor;
};

const PlansComparisonTable = ({
    children,
    heading = 'Find the plan that matches your needs.',
    description = 'Discover the value of an all-in-one Medicare Advantage plan. Choose from plans that may include additional coverage and benefits like these:',
    backgroundsurface = 'bg-surface-50',
    textColor = 'text-default',
}: React.PropsWithChildren<Props>) => {
    const { stateAbbr, countyName } = useAppSelector((state) => state.global.geoLocation);
    const isExcludedCounty =
        stateAbbr && constants.EXCLUDED_COUNTIES.includes(`${countyName}, ${stateAbbr}`);
    if (isExcludedCounty) {
        return null;
    }

    return (
        <>
            <div id="plansComparisonTableAnchor"></div>
            <section className={classNames('py-24', backgroundsurface)}>
                <Grid>
                    {/* Value Prop Content */}
                    <div className="col-span-4 md:col-span-8 lg:col-span-12">
                        <div className="text-center lg:text-left">
                            <h2 className="text-center text-default mb-2 md:mb-3 lg:mb-4 font-poppins font-bold text-24 leading-32 md:text-32 md:leading-40 lg:text-40 lg:leading-56">
                                {heading}
                            </h2>
                            <p className="text-center font-sans text-base mb-4 md:mb-8 print:break-inside-avoid">
                                {description}
                            </p>

                            <div>{children}</div>

                            <div className="flex justify-center mt-12">
                                <a
                                    href={process.env.GATSBY_EHMP_URL}
                                    data-wa-link="Compare Chart: shop plans"
                                    className={classNames(
                                        'text-white bg-[#FA6200]',
                                        'rounded-full font-poppins font-bold text-20',
                                        'px-12 py-3 w-full md:w-auto'
                                    )}
                                >
                                    Compare Plans
                                </a>
                            </div>
                        </div>
                    </div>
                </Grid>
            </section>
        </>
    );
};

export default PlansComparisonTable;
